const routes = [
    {
        path: "/bulk/note/entry/:sectionId",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission:'course_search'
        }
    }
];

export default routes;
